export default {"src":"/_next/static/image/public/images/icons4/7.9372f61be9547f48d629588d8a7d3e80.svg","height":42,"width":42};